// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"28c1baa7","415":"1eef2a8e","875":"e41e8bc5"}[chunkId] + ".chunk.js";
};